import { Redirect, Route, Switch } from 'react-router-dom';
import Alert from './Alert';

import Background from './Background';
import Badge from './Badge';
import Button from './Button'
import Card from './Card';
import Form from './Form/Form';
import Gallery from './Gallery';
import Hr from './Hr';
import List from './List';
import Loader from './Loader';
import Modal from './Modal';
import Navigation from './Navigation';
import Spacer from './Spacer';
import Table from './Table';
import Text from './Text';


const Elements = () => {
    return <div className='container xxl'>
        <Switch>
            <Route exact path='/elements/bg' render={() => <Background />} />
            <Route exact path='/elements/button' render={() => <Button />} />
            <Route exact path='/elements/badge' render={() => <Badge />} />
            <Route exact path='/elements/card' render={() => <Card />} />
            <Route exact path='/elements/loader' render={() => <Loader />} />
            <Route exact path='/elements/table' render={() => <Table />} />
            <Route exact path='/elements/text' render={() => <Text />} />
            <Route exact path='/elements/nav' render={() => <Navigation />} />
            <Route exact path='/elements/modal' render={() => <Modal />} />
            <Route exact path='/elements/form' render={() => <Form />} />
            <Route exact path='/elements/spacer' render={() => <Spacer />} />
            <Route exact path='/elements/gallery' render={() => <Gallery />} />
            <Route exact path='/elements/alert' render={() => <Alert />} />
            <Route exact path='/elements/list' render={() => <List />} />
            <Route exact path='/elements/hr' render={() => <Hr />} />
            <Redirect from='/elements' to='/elements/bg' />
        </Switch>
    </div>
}

export default Elements